export default function FirmaIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 48}
      height={height ? height : width ? width : 48}
      viewBox="0 0 21 20"
      style={{ marginTop: "-2px" }}
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g transform="translate(1.000000, 0.000000)" stroke="currentColor">
          <path
            d="M4.05536723,11.7898245 C4.05536894,12.9683265 5.01037942,13.9238776 6.18888119,13.9245462 C7.36738297,13.9252149 8.32347714,12.9707481 8.32481616,11.7922469 C8.32615518,10.6137457 7.37223241,9.65710876 6.19373215,9.65509938 C5.62693747,9.65413298 5.08302624,9.87861417 4.68190005,10.2790576 C4.28077387,10.679501 4.0553664,11.223029 4.05536723,11.7898245 Z"
            strokeWidth="1.5"
          ></path>
          <path
            d="M8.8589538,18.194 L8.8589538,17.6607737 C8.8589538,16.1870535 7.66426754,14.9923672 6.19054735,14.9923672 C4.71682717,14.9923672 3.52214091,16.1870535 3.52214091,17.6607737 L3.52214091,18.194"
            strokeWidth="1.5"
          ></path>
          <path
            d="M10.4595427,11.7898245 C10.4595444,12.9683265 11.4145549,13.9238776 12.5930567,13.9245462 C13.7715584,13.9252149 14.7276526,12.9707481 14.7289916,11.7922469 C14.7303306,10.6137457 13.7764079,9.65710876 12.5979076,9.65509938 C12.0311129,9.65413298 11.4872017,9.87861417 11.0860755,10.2790576 C10.6849493,10.679501 10.4595419,11.223029 10.4595427,11.7898245 L10.4595427,11.7898245 Z"
            strokeWidth="1.5"
          ></path>
          <path
            d="M15.2658591,18.194 L15.2658591,17.6607737 C15.2642215,16.5836515 14.6150509,15.6131706 13.6201249,15.2004753 C12.625199,14.7877801 11.4797056,15.0138343 10.7161465,15.7735529"
            strokeWidth="1.5"
          ></path>
          <path
            d="M18.194,18.194 L18.194,10.2224271 C18.194,9.69199415 17.9832863,9.18328632 17.6082136,8.80821356 L10.8082136,2.00821356 C10.027165,1.22716498 8.76083502,1.22716498 7.97978644,2.00821356 L1.17978644,8.80821356 C0.804713681,9.18328632 0.594,9.69199415 0.594,10.2224271 L0.594,18.194"
            strokeWidth="1.7"
          ></path>
        </g>
      </g>
    </svg>
  );
}
